<template>
  <div class="credible">
    <el-popover
      placement="bottom-start"
      :width="lang === 'CN' ? 330 : 420"
      trigger="hover"
      :show-arrow="false"
      popper-class="popper-credible"
    >
      <div style="font-weight: 700">
        <div v-if="credibilityValue === 1">
          {{ $t('assist.credibleAnounce.marginalCredibility') }}
        </div>
        <div v-else-if="credibilityValue === 2">
          {{ $t('assist.credibleAnounce.acceptibleCredibility') }}
        </div>
        <div v-else-if="credibilityValue === 3">
          {{ $t('assist.credibleAnounce.goodCredibility') }}
        </div>
        <div v-else-if="credibilityValue === 4">
          {{ $t('assist.credibleAnounce.exceptionalCredibility') }}
        </div>
      </div>
      <div class="credible-tips">
        {{ $t('assist.credibleAnounce.standard') }}
      </div>
      <div :class="lang === 'CN' ? 'credible-state-cn' : 'credible-state-en'">
        {{ $t('assist.credibleAnounce.anouncement') }}
      </div>

      <template #reference>
        <div class="icon">
          <img
            v-if="credibilityValue === 1"
            class="credibility"
            src="@/common/image/assist/credible-level1.svg"
            alt=""
          />
          <img
            v-else-if="credibilityValue === 2"
            class="credibility"
            src="@/common/image/assist/credible-level2.svg"
            alt=""
          />
          <img
            v-else-if="credibilityValue === 3"
            class="credibility"
            src="@/common/image/assist/credible-level3.svg"
            alt=""
          />
          <img
            v-else-if="credibilityValue === 4"
            class="credibility"
            src="@/common/image/assist/credible-level4.svg"
            alt=""
          />
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { getLang } from '@/hooks/lang'

export default defineComponent({
  props: {
    credibilityValue: {
      type: Number,
      default: -1,
    },
  },
  setup() {
    const lang = getLang()
    return {
      lang,
    }
  },
})
</script>

<style lang="less" scoped>
.credible {
  .icon {
    margin-left: -20px;
    cursor: pointer;
    position: absolute;
  }
}
</style>
<style>
.popper-credible {
  word-break: break-word;
}
.popper-credible .credible-tips {
  font-size: 12px;
}
.popper-credible .credible-state-cn {
  font-size: 10px;
  color: #c0c4cc;
  transform: scale(0.82);
  margin-left: -33px;
  margin-right: -40px;
}
.popper-credible .credible-state-en {
  font-size: 10px;
  color: #c0c4cc;
  transform: scale(0.82);
  margin: 0px -40px;
}
</style>

